import React, { useLayoutEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { createFrequentPassageRequest } from '@shared/frequent-passage-requests/endpoints/createFrequentPassageRequest';
import { FrequentPassageRequestForm } from '@shared/frequent-passage-requests/components/FrequentPassageRequestForm';

import ModalToBody from '../../../base/ModalToBody';
import { FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY } from '../../../hooks/api/frequent-passage-requests/useFrequentPassageRequests';
import { REGISTRATION_FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY } from '../../../hooks/api/frequent-passage-requests/useRegistrationFrequentPassageRequests';
import { Registration } from '../../../hooks/api/utils/types';

type Props = {
  registration: Registration;
};

export default function CreateFrequentPassageRequestButton({ registration }: Props) {
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);

  function openModal() {
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
  }

  function handleSave() {
    queryClient.invalidateQueries(REGISTRATION_FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY);
    queryClient.invalidateQueries(FREQUENT_PASSAGE_REQUESTS_ALL_QUERY_KEY);
    queryClient.invalidateQueries('frequent-passage-requests');

    closeModal();
  }

  useLayoutEffect(() => {
    if (showModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [showModal]);

  return (
    <div>
      <button type="button" className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon" onClick={openModal}>
        <span>
          <i className="la la-plus" />
          <span>
            <Trans>RegistrationFrequentPassageRequestButton</Trans>
          </span>
        </span>
      </button>

      <ModalToBody>
        <div
          className="modal fade show"
          id="m_modal_4"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          style={{
            display: showModal ? 'block' : 'none',
            zIndex: 1039,
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Request Transport
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {showModal && (
                <div className="p-8">
                  <FrequentPassageRequestForm
                    registrationId={registration.id}
                    action={createFrequentPassageRequest}
                    onSave={handleSave}
                    onCancel={closeModal}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
          style={{
            display: showModal ? 'block' : 'none',
            zIndex: 1038,
          }}
        />
      </ModalToBody>
    </div>
  );
}
